import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import Menu from './Menu';
import LandingPageOffers from './LandingPageOffers';
import LandingPagePrayes from './landingPagePrayes';
import Footer from './Footer';
import OffersPageInLandingPage from './OffersPageInLandingPage';
import GeneralSearch from './GeneralSearch';
import Sidebar from './SideBar';
import "./AnimatedBackground.css";
import AnimatedBackground from './AnimatedBackground';
import WaterDropEffect from './DropofWater';

const backgrounds = ['bg-landing-page', 'bg-second-landingpage', 'bg-third-landingpage']; // Tailwind background classes
const Typewriter = ({ texts, speed = 150, delay = 2000 }) => {
  const [currentText, setCurrentText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showCursor, setShowCursor] = useState(true);


  useEffect(() => {
    const handleTyping = () => {
      const fullText = texts[currentIndex];
      const updatedText = isDeleting
        ? fullText.substring(0, currentText.length - 1)
        : fullText.substring(0, currentText.length + 1);

      setCurrentText(updatedText);

      if (!isDeleting && updatedText === fullText) {
        setTimeout(() => setIsDeleting(true), delay); // Pause before deleting
      } else if (isDeleting && updatedText === "") {
        setIsDeleting(false);
        setCurrentIndex((prev) => (prev + 1) % texts.length); // Move to next text
      }
    };

    const timer = setTimeout(handleTyping, isDeleting ? speed / 2 : speed);

    return () => clearTimeout(timer);
  }, [currentText, isDeleting, currentIndex, texts, speed, delay]);

  // Cursor blinking effect
  useEffect(() => {
    const cursorTimer = setInterval(() => {
      setShowCursor((prev) => !prev);
    }, 500); // Blink every 500ms

    return () => clearInterval(cursorTimer);
  }, []);

  return (
    <span>
      {currentText}
      <span className={`ml-1 ${showCursor ? "opacity-100" : "opacity-0"}`}>
        |
      </span>
    </span>
  );
};

const LandingPage = () => {
  const [scrollY, setScrollY] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [currentBackground, setCurrentBackground] = useState(0);
  const sectionRef = useRef(null);
  
  // Rotate background every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBackground((prev) => (prev + 1) % backgrounds.length);
    }, 5000); // 5 seconds
    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  const handleScroll = () => {
    setScrollY(window.scrollY); // Update scroll position
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        setIsVisible(entry.isIntersecting); // Check if the section is in view
      },
      { threshold: 0.5 } // Trigger animation when 50% of the section is visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const ServiceCard = ({ title, description }) => (
    <motion.div
      className="bg-green-100 rounded-xl shadow-md hover:shadow-lg transition-all duration-300"
      initial={{ opacity: 0, y: -100 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        delay: 0.3,
        type: 'spring',
        stiffness: 50,
      }}
    >
      <div className='w-full h-full backdrop-blur-md rounded-xl p-10 text-gray-900 font-normal shadow-lg '>
        <h3 className="text-2xl font-semibold text-green-300 mb-4">{title}</h3>
        <p className="text-lg">{description}</p>
      </div>
      
    </motion.div>
  );

  return (
    <div className="w-full flex flex-col justify-center items-center">
      <Menu />
      <Sidebar />
      <WaterDropEffect containerRef={sectionRef} />
      {/* Landing Page Section with Dynamic Background */}
      <motion.div
        className={`flex-col ${backgrounds[currentBackground]} bg-cover bg-center w-full flex h-screen justify-center items-center`}
        id="home"
        initial={{ opacity: 1, y: 0 }}
        animate={{
          opacity: isVisible ? 1 : 0,
          y: isVisible ? 0 : 100,
        }}
        transition={{
          delay: 0.5,
          type: 'spring',
          stiffness: 50,
        }}
        ref={sectionRef}
      >
        <div className="flex flex-col justify-center items-center mt-48">
        <motion.h1
        className="text-7xl text-white font-medium text-center"
        style={{fontFamily:'Reem Kufi'}}
        initial={{ opacity: 0, y: -50 }}
        animate={{
          opacity: isVisible ? 1 : 0,
          y: isVisible ? 0 : -50,
        }}
        transition={{
          delay: 0.6,
          type: "spring",
          stiffness: 50,
        }}
      >
        <span className="text-[#45B654]">  رحــال </span>
         دليل سياحتك
        <span className="text-[#45B654]"> الحــلال </span>
        <br /><br/>
        
      </motion.h1>
      <h1  style={{fontFamily:'Reem Kufi'}} className='text-5xl text-white font-light text-center -mt-9 mb-10'> 
        <Typewriter
         
          texts={[
            "تخطيط لرحلة لا تُنسى ",
            "أماكن إقامة مميزة ",
            "مطاعم تلبي احتياجاتك ",
          ]}
         
        />
        </h1>
     
      <GeneralSearch />
          
        </div>
      </motion.div>
      {/* Offers Page  */}
      <motion.div
        className="flex w-full flex-col justify-center items-center h-screen bg-gray-100"
        initial={{ opacity: 1, y: -100 }}
        animate={{
          opacity: scrollY > 1000 ? 0 : 1,
          y: scrollY > 1000 ? 100 : 0,
        }}
        transition={{
          delay: 0.9,
          type: 'spring',
          stiffness: 50,
        }}
      >
        <h1 className="text-7xl text-center text-[#26B75D] font-bold mt-10" style={{fontFamily:'Reem Kufi'}}>
            احجز رحلتك مع عروضنا
          </h1>
          <LandingPageOffers containerRef={sectionRef} />
        </motion.div>
      {/* Services Section */}
  
        <AnimatedBackground  scrollY={scrollY}/>
      
      
      {/* Explore page */}
      <motion.div
        className="flex w-full flex-col justify-center items-center h-screen bg-gradient-to-tr from-gray-100 to-gray-400"
        initial={{ opacity: 0, y: -100 }}
        animate={{
          opacity: scrollY > 1000 ? 1 : 0,
          y: scrollY > 1000 ? 0 : -100,
        }}
        id="explore"
        transition={{
          delay: 0.9,
          type: 'spring',
          stiffness: 50,
        }}
      >
        <OffersPageInLandingPage scrollY={scrollY} />
      </motion.div>

      {/* Religious Practices Section */}
      <motion.div
        className="flex w-full flex-col justify-center items-center h-screen bg-gradient-to-tr from-green-100 to-green-300"
        initial={{ opacity: 0, y: -100 }}
        animate={{
          opacity: scrollY > 1000 ? 1 : 0,
          y: scrollY > 1000 ? 0 : -100,
        }}
        id="prayers"
        transition={{
          delay: 0.9,
          type: 'spring',
          stiffness: 50,
        }}
      >
        <LandingPagePrayes scrollY={scrollY}/>
      </motion.div>
     

      {/* Testimonials Section */}
      <motion.div
        className="w-full bg-gradient-to-r from-green-200 to-gray-200 text-white py-16"
        id="testimonials"
        initial={{ opacity: 0, y: -100 }}
        animate={{
          opacity: scrollY > 2500 ? 1 : 0,
          y: scrollY > 2500 ? 0 : -100,
        }}
        transition={{ delay: 1.4, type: 'spring', stiffness: 50 }}
      >
        <div className="text-center max-w-6xl h-screen flex justify-center items-center flex-col mx-auto">
          <h2 className="text-7xl font-semibold text-[#45B654] mb-10" style={{fontFamily:'Reem Kufi'}}>آراء العملاء</h2>
          <p className="text-xl mb-20 text-[#0B4B41]">ماذا يقول عملاؤنا عن تجربتهم معنا؟</p>
          <div className="flex justify-center space-x-8">
            <div className="bg-[#0B4B41] p-8 rounded-lg shadow-lg mx-2">
              <p className="text-xl">"تجربة لا تُنسى، وكل شيء كان مذهلاً. رحلاتنا كانت منظمة بشكل رائع!"</p>
              <p className="mt-4 text-lg">أحمد سعيد</p>
            </div>
            <div className="bg-[#0B4B41] p-8 rounded-lg shadow-lg mx-2">
              <p className="text-xl">"خدمة رائعة، رحلاتنا كانت آمنة ومريحة. سأحجز مرة أخرى بالتأكيد!"</p>
              <p className="mt-4 text-lg">سارة محمد</p>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Services Cards Section */}
      <motion.div
        className="flex w-full flex-col justify-center items-center h-screen bg-gradient-to-tr from-gray-50 to-gray-300"
        initial={{ opacity: 0, y: -100 }}
        animate={{
          opacity: scrollY > 1500 ? 1 : 0,
          y: scrollY > 1500 ? 0 : -100,
        }}
        transition={{ delay: 1, type: 'spring', stiffness: 50 }}
        id="why-us"
      >
        <motion.section
          className="py-16 flex flex-col justify-center items-center"
          initial={{ opacity: 0, y: -100 }}
          animate={{
            opacity: scrollY > 1500 ? 1 : 0,
            y: scrollY > 1500 ? 0 : -100,
          }}
          transition={{ delay: 1, type: 'spring', stiffness: 50 }}
          id='why-choose-us'
        >
              <motion.div
        className="max-w-6xl mx-auto text-center py-16"
        initial={{ opacity: 0, y: -100 }}
        animate={{
          opacity: scrollY > 500 ? 1 : 0,
          y: scrollY > 500 ? 0 : -100,
        }}
        transition={{
          delay: 0.8,
          type: 'spring',
          stiffness: 50,
        }}
      >
        <h2 className="text-6xl font-semibold text-[#1cc752] mb-8">
          لماذا تختار الحجز عبر <span style={{fontFamily:'Reem Kufi'}} className='text-7xl'>رحــال </span>؟
        </h2>
        <p className="text-2xl text-gray-800">
          نحن في منصتنا ملتزمون بتوفير رحلات آمنة ومريحة وغنية للمسافرين المسلمين حول العالم. إليك لماذا يجب أن تختارنا:
        </p>
    
      </motion.div>
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-3xl font-semibold text-gray-800 mb-12">خدمات السفر لدينا</h2>
            <div className="grid md:grid-cols-3 gap-12 px-4">
              <ServiceCard
                title="فنادق حلال"
                description="إقامة في فنادق مع مرافق للصلاة ومساحات مفصولة."
              />
              <ServiceCard
                title="مطاعم حلال"
                description="استمتع بمأكولات حلال لذيذة حول العالم مع ضمان الأصالة."
              />
              <ServiceCard
                title="جولات إرشادية"
                description="انضم إلى جولات إرشادية تحترم احتياجاتك الثقافية والدينية مع مسارات مناسبة للمسلمين."
              />
            </div>
          </div>
              
        </motion.section>
      </motion.div>
      

      {/* Contact Us Section */}
      <motion.div
        className="w-full bg-gray-200 py-16"
        id="contact"
        initial={{ opacity: 0, y: -100 }}
        animate={{
          opacity: scrollY > 3000 ? 1 : 0,
          y: scrollY > 3000 ? 0 : -100,
        }}
        transition={{ delay: 1.6, type: 'spring', stiffness: 50 }}
      >
        <div className="text-center max-w-6xl mx-auto h-screen flex justify-center items-center flex-col">
          <h2 className="text-3xl font-semibold text-[#45B654] mb-8">تواصل معنا</h2>
          <p className="text-lg mb-8">لأي استفسارات أو طلبات، لا تتردد في الاتصال بنا.</p>
          <div className="space-y-4">
            <input
              className="w-full p-4 rounded-lg text-lg"
              type="text"
              placeholder="الاسم"
            />
            <input
              className="w-full p-4 rounded-lg text-lg"
              type="email"
              placeholder="البريد الإلكتروني"
            />
            <textarea
              className="w-full p-4 rounded-lg text-lg"
              placeholder="رسالتك"
              rows="4"
            />
            <button className="px-6 py-4 bg-[#45B654] text-white rounded-full text-xl">
              إرسال الرسالة
            </button>
          </div>
        </div>

      </motion.div>
      <Footer />
    </div>
  );
};

export default LandingPage;
